// extracted by mini-css-extract-plugin
module.exports = {"itemsForMobile":"PortfolioItems-module--itemsForMobile--2dJrW","itemsForDesktop":"PortfolioItems-module--itemsForDesktop--2IgZL"};